// extracted by mini-css-extract-plugin
export default {"items":"post-shares-modal_items__7SRag","row":"post-shares-modal_row__NgaSO","rowItem":"post-shares-modal_rowItem__uBC3z"};